module.exports = __webpack_public_path__ + "img/1 (64).417c99b6.png";